import { Link } from "react-router-dom";
import { GiTooth } from "react-icons/gi";
import { FiFacebook, FiInstagram, FiMapPin, FiClock } from "react-icons/fi";
import { CLINIC } from "../../data/clinic";
import { treatments } from "../../data/treatments";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();
  const featuredTreatments = treatments.slice(0, 5);

  return (
    <footer className="site-footer">
      <div className="site-footer__tooth-bg" aria-hidden="true">
        <GiTooth />
      </div>
      <div className="container-xl site-footer__grid">
        <div className="site-footer__col site-footer__brand">
          <div className="site-footer__logo">
            <span className="site-footer__logo-icon">
              <GiTooth />
            </span>
            <span>ROOTS</span>
          </div>
          <p>
            {CLINIC.name} provides multispeciality dental care in {CLINIC.address.city}, focused on
            comfort, precision and healthier smiles.
          </p>
          <div className="site-footer__socials">
            <span className="site-footer__social" aria-hidden="true">
              <FiFacebook />
            </span>
            <span className="site-footer__social" aria-hidden="true">
              <FiInstagram />
            </span>
          </div>
        </div>

        <div className="site-footer__col">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/treatments">Treatments</Link></li>
            <li><Link to="/doctors">Doctors</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="site-footer__col">
          <h4>Treatments</h4>
          <ul>
            {featuredTreatments.map((t) => (
              <li key={t.slug}>
                <Link to={`/treatments/${t.slug}`}>{t.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="site-footer__col">
          <h4>Visit Us</h4>
          <p className="site-footer__address">
            <FiMapPin />
            <span>
              {CLINIC.address.line1}
              <br />
              {CLINIC.address.line2}
              <br />
              {CLINIC.address.line3}
              <br />
              {CLINIC.address.area}, {CLINIC.address.city} – {CLINIC.address.pincode}
              <br />
              {CLINIC.address.state}
            </span>
          </p>
          <h4 className="site-footer__hours-label">Opening Hours</h4>
          <p className="site-footer__hours">
            <FiClock />
            <span>
              {CLINIC.hours}
              <br />
              {CLINIC.hoursDays}
            </span>
          </p>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="container-xl site-footer__bottom-inner">
          <p>© {year} {CLINIC.name}. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
